import type { CountryConfig } from "@orvis/core";
import { ADMOB_CR } from "../ads.js";
import { defaultDarkTheme } from "../theme.js";

/**
 * Costa Rica config.
 *   - Firestore collection: `cr` (legacy/frontend/com.orvis.crc/app/services/db.service.ts)
 *   - Play Store id:       com.orvis.crc (frontend/.../app.json)
 *   - News feeds: multiple national outlets, aggregated by the server-side
 *     `updateNews` Cloud Function into `cr/news`; the web build reads the
 *     Firestore doc first (no CORS issues) and falls back to these urls
 *     directly on Capacitor WebViews where CORS doesn't apply.
 */
export const cr: CountryConfig = {
  code: "cr",
  name: "Costa Rica",
  flag: "🇨🇷",
  defaultLocale: "es",
  bundleId: "com.orvis.crc",
  newsSources: [
    {
      id: "nacion",
      name: "La Nación",
      feedUrl: "https://www.nacion.com/arc/outboundfeeds/rss/?outputType=xml",
      kind: "rss",
      language: "es",
      homepage: "https://www.nacion.com/",
      enabled: true,
      category: "general",
    },
    // Note: crhoy.com/feed + teletica.com/rss.xml both retired their RSS
    // endpoints in 2026 — dropped here and from newsUpdaters.js's FEEDS.
    {
      id: "delfino",
      name: "Delfino",
      feedUrl: "https://delfino.cr/feed",
      kind: "rss",
      language: "es",
      homepage: "https://delfino.cr/",
      enabled: true,
      category: "general",
    },
  ],
  ads: {
    publisherId: ADMOB_CR.publisherId,
    bannerUnitId: ADMOB_CR.banner,
    interstitialUnitId: ADMOB_CR.interstitialPlayChannel,
    appOpenUnitId: ADMOB_CR.appOpen,
  },
  theme: defaultDarkTheme,
};
